<template>
  <div
    class="bg-section-5 w-full h-screen bg-no-repeat bg-cover relative overflow-hidden"
  >
    <div class="slider-cont w-full">
      <div class="slider-wrapper w-full">
        <VueSlickCarousel
          ref="bossSlider"
          v-bind="settings"
          @beforeChange="beforeChangeCarousel"
        >
          <div
            class="boss-slide"
            v-for="(bossSlide, index) in bossData"
            :key="index"
          >
            <div class="flex flex-row h-screen">
              <div class="2xl:w-8/12 lg:w-7/12 relative">
                <img
                  class="boss-img w-full absolute opacity-0 2xl:-bottom-14.5/10 2xl:-left-32 lg:bottom-0 lg:left-0"
                  :src="`${imgPath}/Section05/${bossSlide.bossImg}`"
                />
              </div>
              <div
                class="description-wrapper relative 2xl:w-4/12 xl:w-5/12 lg:w-5/12 flex flex-col justify-center"
              >
                <div
                  class="absolute w-full 2xl:h-712 xl:h-550 xl: flex flex-row 4xl:-left-3/10 2xl:-left-4/10 lg:-left-3/10"
                >
                  <div class="w-5/6 h-full">
                    <h1
                      class="boss-name font-rakkas 2xl:text-8.4xl xl:text-8xl lg:text-4.4 leading-8.6 text-white opacity-0"
                      v-html="bossSlide.name"
                    ></h1>
                    <h3
                      class="boss-subtitle text-white 2xl:text-2.2 xl:text-1.8 lg:text-1.6 font-mulish-bold opacity-0 4xl:mt-14 xl:mt-8"
                      v-html="bossSlide.subtitle"
                    ></h3>
                    <p
                      class="boss-desc font-mulish-medium text-very-light-gray tracking-normal mt-6 opacity-0 xl:w-11/12 4xl:leading-2.8 2xl:leading-1.8 4xl:text-2 2xl:text-1.6 xl:text-1.4 lg:leading-tight lg:text-1.2"
                      v-html="bossSlide.desc"
                    ></p>
                  </div>
                  <div class="w-1/6 h-800 flex items-center 2xl:ml-4">
                    <ul>
                      <li
                        class="relative w-66 h-66 mt-6 cursor-pointer "
                        v-for="(dots, index) in bossPaging"
                        :key="dots[index]"
                        @click="goToSlide(index)"
                      >
                        <span
                          :class="
                            activePage === index
                              ? 'bg-opacity-0 bg-transparent shadow-dots-active'
                              : 'bg-black bg-opacity-75'
                          "
                          class="absolute inset-0 mx-auto w-66 h-66 rounded-full "
                        ></span>
                        <img
                          class="w-full"
                          :src="`${imgPath}/Section05/${bossPaging[index]}`"
                        />
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </VueSlickCarousel>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
export default {
  components: { VueSlickCarousel },
  data: function() {
    return {
      settings: {
        dots: false,
        arrows: false,
        autoplay: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        useCSS: false,
        speed: 5000,
        autoplaySpeed: 5000,
      },
      activePage: 0,
    };
  },
  methods: {
    resetAnimation: function() {
      this.$store.commit('ANIMATION/RESET_BOSS_SECTION');
    },
    initAnimation: function() {
      this.$store.commit('ANIMATION/INIT_BOSS_SECTION');
    },
    beforeChangeCarousel: function(oldIndex, newIndex) {
      //console.log(newIndex);
      this.activePage = newIndex;
      this.resetAnimation();
      this.initAnimation();
    },
    goToSlide: function(index) {
      this.$refs.bossSlider.goTo(index);
    },
  },
  computed: {
    ...mapState({
      imgPath: state => state.AppConfig.imgPath,
      bossData: state => state.BossSection.bossData,
      bossPaging: state => state.BossSection.bossPaging,
      pageNumber: state => state.AppConfig.pageNumber,
    }),
  },
};
</script>

<style lang="postcss" scoped>
.slider-wrapper >>> .slick-track {
  @apply flex;
}
.slider-wrapper >>> .slick-slide {
  @apply md:h-full;
}
.slider-wrapper >>> .slick-list {
  @apply overflow-visible;
}
</style>
